import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useScrollToTop } from '../../hooks/useScrollToTop';
import './Footer.css';

const Footer: React.FC = () => {
  const scrollToTop = useScrollToTop();
  return (
    <footer className="footer mt-auto py-5 bg-dark text-light">
      <Container>
        <Row>
          <Col md={4} className="footer-col">
            <Link to="/" className="footer-logo-link" aria-label="Home" onClick={scrollToTop}>
              <img
                src="/assets/skytion/brand/skytion logo png.png"
                alt="Skytion Enterprises Logo"
                className="footer-logo mb-3"
                style={{ maxWidth: '140px', height: 'auto', cursor: 'pointer' }}
              />
            </Link>
            <h5>Skytion Enterprises</h5>
            <p>Skysun Brand • Est. 2022 • Noida</p>
            <p className="footer-tagline">Premium tissue products from virgin & recycled pulp. Serving India, USA, Indonesia with 80% women workforce.</p>
          </Col>
          <Col md={4} className="footer-col">
            <h5>Quick Links</h5>
            <ul className="list-unstyled">
              <li><Link to="/products" onClick={scrollToTop}>All Products</Link></li>
              <li><Link to="/products/dining-tissue" onClick={scrollToTop}>Dining Tissue</Link></li>
              <li><Link to="/products/toilet-roll" onClick={scrollToTop}>Toilet Roll</Link></li>
              <li><Link to="/manufacturing" onClick={scrollToTop}>Manufacturing</Link></li>
              <li><Link to="/about" onClick={scrollToTop}>About Us</Link></li>
              <li><Link to="/contact" onClick={scrollToTop}>Contact</Link></li>
            </ul>
            <a
              href="/SKYTION-Catalogue.pdf"
              download
              className="mt-3 inline-flex items-center justify-center px-4 py-2 font-medium text-white transition-colors rounded-md shadow-sm bg-slate-800 hover:bg-slate-700 w-full sm:w-auto text-sm"
              style={{ textDecoration: 'none' }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="mr-2">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
              Download Full Catalogue
            </a>
          </Col>
          <Col md={4} className="footer-col">
            <h5>Contact Us</h5>
            <ul className="list-unstyled">
              <li className="mb-2">Email: info@skytion.in</li>
              <li className="mb-2">Phone: +91 8920065965</li>
              <li>
                <div className="mt-3">
                  <p className="mb-0">Ecotech Phase 3</p>
                  <p className="mb-0">Gautam Buddha Nagar, Noida</p>
                </div>
              </li>
            </ul>
          </Col>
        </Row>
        {/* Technology Partners section removed from footer */}
        <Row className="mt-4">
          <Col className="text-center">
            <p className="mb-0 footer-copyright">&copy; 2025 Skytion.in - SKYTION ENTERPRISES. All rights reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;